"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestonePeriod = exports.MilestoneType = void 0;
var MilestoneType;
(function (MilestoneType) {
    MilestoneType["UNKNOWN"] = "UNKNOWN";
    MilestoneType["HEALTH"] = "HEALTH";
    MilestoneType["GROWTH"] = "GROWTH";
    MilestoneType["DIET"] = "DIET";
    MilestoneType["EXERCISE"] = "EXERCISE";
    MilestoneType["GROOMING"] = "GROOMING";
    MilestoneType["HAIR"] = "HAIR";
    MilestoneType["NAILS"] = "NAILS";
    MilestoneType["TEETH"] = "TEETH";
    MilestoneType["MEDICAL"] = "MEDICAL";
    MilestoneType["VETERINARY"] = "VETERINARY";
    MilestoneType["INSURANCE"] = "INSURANCE";
    MilestoneType["TRAINING"] = "TRAINING";
    MilestoneType["BEHAVIOR"] = "BEHAVIOR";
    MilestoneType["WALKING"] = "WALKING";
    MilestoneType["SOCIAL"] = "SOCIAL";
    MilestoneType["HOME"] = "HOME";
})(MilestoneType = exports.MilestoneType || (exports.MilestoneType = {}));
var MilestonePeriod;
(function (MilestonePeriod) {
    MilestonePeriod["STATIC"] = "STATIC";
    MilestonePeriod["UNKNOWN"] = "UNKNOWN";
    MilestonePeriod["PRE_BIRTH"] = "PRE_BIRTH";
    MilestonePeriod["EARLY_DEVELOPMENT"] = "EARLY_DEVELOPMENT";
    MilestonePeriod["PUPPY_DEVELOPMENT"] = "PUPPY_DEVELOPMENT";
    MilestonePeriod["PREADOLESCENCE"] = "PREADOLESCENCE";
    MilestonePeriod["ADOLESCENCE"] = "ADOLESCENCE";
    MilestonePeriod["EARLY_ADULTHOOD"] = "EARLY_ADULTHOOD";
    MilestonePeriod["ADULTHOOD"] = "ADULTHOOD";
    MilestonePeriod["SENIOR"] = "SENIOR";
})(MilestonePeriod = exports.MilestonePeriod || (exports.MilestonePeriod = {}));
